import { Component, Input, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
 
@Component({
    selector: 'app-roster-edit-student',
    templateUrl: './edit-student.component.html',
    styleUrls: ['./edit-student.component.scss']
})
export class EditStudentComponent implements OnInit {
    constructor(private route: ActivatedRoute) {
    }

    termCode: string;
    crn: string;


    ngOnInit(): void {
        this.termCode = this.route.snapshot.paramMap.get('termCode');
        this.crn = this.route.snapshot.paramMap.get('crn');
    }
}
